<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات گواهی نامه</h5>

    <div>

      <app-DataEntityDeviceInfo 
        [inner_calibration_id]="Calibration_Device_Id"
        (outter_Calibration_Device)="Set_CalibrationDeviceInfo_click($event)">
        
      </app-DataEntityDeviceInfo>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-4">
              <app-DataEntityLabAddress
              [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>

          <div class="form-group col-md-4">
            <app-DataEntityLinearity
            [inner_Calibration_Device_Id]="Calibration_Device_Id"
            [inner_Calibration_Display]="Calibration_Device.display_linearity">

          </app-DataEntityLinearity>
        </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-DataEntityCertificateNote [inner_Calibration_Device_Id]="Calibration_Device_Id">

      </app-DataEntityCertificateNote>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>

        <div class="row">

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> واحد Brix </label>
            <select class="custom-select" [(ngModel)]="unit_Brix" name="unit_Brix">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> واحد nD </label>
            <select class="custom-select" [(ngModel)]="unit_nD" name="unit_nD">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>



        </div>

      </form>

      <br />
      <hr />
      <br />


      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> TYPE </label>
            <select class="custom-select" [(ngModel)]="Type_txt" name="Type_txt">
              <option value="">انتخاب کنید</option>
              <option value="DIGITAL">Digital</option>
              <option value="ANALOG">Analog</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MODEL </label>
            <input [(ngModel)]="Model_txt" name="Model_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>


        </div>
      </form>

      <br />
      <hr />
      <br />


      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Working Range </label>
            <input [(ngModel)]="working_temp_txt" name="working_temp_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Reference Temperature </label>
            <input [(ngModel)]="reference_temperature" name="reference_temperature" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> آیا تنظیم انجام شده است؟ </label>
            <select class="custom-select" [(ngModel)]="has_before" name="has_before">
              <option value="1">بله</option>
              <option value="0">خیر</option>

            </select>
          </div>


        </div>
      </form>


      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بارگذاری فایل پیوست : </label>
            <input type="file" #file_pdf>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import2" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import2" type="button" class="btn btn-info"
              (click)="upload_file_pdf(file_pdf.files)"> بارگذاری فایل پیوست <i class="fa fa-upload"></i></button>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input formControlName="Temperature_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © before را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input formControlName="Temperature_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input formControlName="Humidity_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) after را وارد نمائید.</small>
          </div>


        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input formControlName="Pressure_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) after را وارد نمائید.</small>
          </div>


        </div>


      </form>

      <br />
      <hr />
      <br />



    </div>

    <form>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> بارگذاری فایل : </label>
          <input type="file" #file_excel>
        </div>
        <div class="form-group col-md-6">
          <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
            (click)="upload_file_excel(file_excel.files,1)"> بارگذاری فایل <i class="fa fa-upload"></i></button>
        </div>
      </div>
    </form>

    <br />
    <hr />
    <br />

    <div>

      <h5 class="card-title">Range / Resolution Brix</h5>


      <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution(1)">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Min Rage </label>
            <input formControlName="range_min" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Max Rage </label>
            <input formControlName="range_max" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> SCALE DIVISION </label>
            <input formControlName="scale" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>
        <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
          style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      </form>

      <div class="table-responsive" *ngIf="DataList_Resolution.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39409b; color: white;">
            <tr>
              <th>#</th>
              <th>Min Range</th>
              <th>Max Range</th>
              <th>SCALE DIVISION</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Resolution">
              <td>{{DataList_Resolution.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.range_min}}</td>
              <td class="EnglishClm">{{item.range_max}}</td>
              <td class="EnglishClm">{{item.scale}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a style="cursor: pointer;" class="dropdown-item"
                        (click)="Delete_Resolution(DataList_Resolution.indexOf(item),1)"><i class="fa fa-remove"></i>
                        حذف
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>


        </table>
      </div>

    </div>

    <br />
    <hr />
    <br />

    <div>

      <h5 class="card-title">Range / Resolution nD</h5>


      <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution(2)">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Min Rage </label>
            <input formControlName="range_min" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Max Rage </label>
            <input formControlName="range_max" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> SCALE DIVISION </label>
            <input formControlName="scale" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>
        <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
          style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      </form>

      <div class="table-responsive" *ngIf="DataList_Resolution_01.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39409b; color: white;">
            <tr>
              <th>#</th>
              <th>Min Range</th>
              <th>Max Range</th>
              <th>SCALE DIVISION</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Resolution_01">
              <td>{{DataList_Resolution_01.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.range_min}}</td>
              <td class="EnglishClm">{{item.range_max}}</td>
              <td class="EnglishClm">{{item.scale}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a style="cursor: pointer;" class="dropdown-item"
                        (click)="Delete_Resolution(DataList_Resolution_01.indexOf(item),2)"><i class="fa fa-remove"></i>
                        حذف
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>


        </table>
      </div>

    </div>



    <div class="table-responsive" *ngIf="Nominal_Value_List.length>0">
      <br />
      <hr />
      <br />

      <h5 class="card-title">Brix</h5>

      <table class="mb-0 table table-bordered table-3 text-center table-striped">

        <thead style="background-color: #395f9b; color: white;">
          <tr>
            <th>#</th>
            <th>Reference Value</th>
            <th>Sample's Indication</th>
            <th>Correction</th>
            <th>Uncertainty</th>
            <th>Converge Factor</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Nominal_Value_List">

            <td>{{Nominal_Value_List.indexOf(item)+1}}</td>
            <td>{{item.reference_Value}}</td>
            <td>{{item.indication}}</td>
            <td>{{item.correction}}</td>
            <td>{{item.uncertainty}}</td>
            <td>{{item.converage}}</td>

          </tr>

        </tbody>

      </table>

    </div>



    <div class="table-responsive" *ngIf="Nominal_Value_List.length>0">
      <br />
      <hr />
      <br />

      <h5 class="card-title">nD</h5>

      <table class="mb-0 table table-bordered table-3 text-center table-striped">

        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Reference Value</th>
            <th>Sample's Indication</th>
            <th>Correction</th>
            <th>Uncertainty</th>
            <th>Converge Factor</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Nominal_Value_List">

            <td>{{Nominal_Value_List.indexOf(item)+1}}</td>
            <td>{{item.reference_Value_2}}</td>
            <td>{{item.indication_2}}</td>
            <td>{{item.correction_2}}</td>
            <td>{{item.uncertainty_2}}</td>
            <td>{{item.converage_2}}</td>

          </tr>

        </tbody>

      </table>
    </div>


    <div>

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-left: 5px;"> سیستم در حال ساخت
        گواهی نامه می باشد. لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-success" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> ثبت اطلاعات گواهی نامه </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-info" style="margin-left: 5px;"><i
          class="fa  fa-edit"></i>
        ویرایش
        اطلاعات گواهی نامه </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf" href="{{CertificateUrlPdf}}"
        style="margin-left: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> فایل گواهی نامه </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" style="margin-left: 5px;"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد گواهی نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>کد گواهی نامه فرم کالبیراسیون کد گواهی نامه <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCodeSerialDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> هشدار </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CodeSerial.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> {{modalRef_CodeSerial_Title}} </h6>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="onSubmit_Code(templateCode,templateCodeSerialDevice,1)">بله،
      مورد تایید است</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CodeSerial.hide()">خیر</button>
  </div>
</ng-template>